import React from 'react';
import { CustomerTransactionTabs } from '../../logic/components';

const CustomerTransactionDetailsRoute = () => {
  return (
    <>
      <div id="container1"></div>
      <div id="container2">
        <CustomerTransactionTabs />
      </div>
    </>
  );
};

export default React.memo(CustomerTransactionDetailsRoute);
